$bog_ui_app_toast $mol_page
	title \Toast
	body /
		<= Description $mol_view
			sub /
				<= description \Toast notifications for user feedback. Click a button to trigger a toast of the corresponding type. Toasts stack vertically and close via the × button.
		<= Buttons_title $mol_view
			sub /
				<= buttons_title \Trigger toasts
		<= Buttons $mol_view
			sub /
				<= Info_button $mol_button_minor
					click? <=> add_info? null
					sub /
						<= info_label \Info
				<= Success_button $mol_button_minor
					click? <=> add_success? null
					sub /
						<= success_label \Success
				<= Warning_button $mol_button_minor
					click? <=> add_warning? null
					sub /
						<= warning_label \Warning
				<= Error_button $mol_button_minor
					click? <=> add_error? null
					sub /
						<= error_label \Error
		<= Manager $bog_ui_toast_manager
